var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column fill-height"},[_c('div',{staticClass:"viewer-wrapper pos-rel"},[_c('div',{attrs:{"id":"gis-viewer"}}),_c('ant-view-loading',{attrs:{"loading":_vm.$wait.is(`tasks.get.*`)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }